export function getSessionStartKey(lesson) {
  const scheduled = lesson?.scheduled_at;
  const ms = new Date(scheduled).getTime();
  if (Number.isFinite(ms)) {
    return String(Math.floor(ms / (60 * 1000)));
  }
  return String(scheduled || lesson?.id || "");
}

export function getTeacherSessionKey(lesson) {
  if (!lesson) return "";
  const classId = lesson?.class_group?.id ?? lesson?.class_group_id;
  const teacherId = lesson?.teacher?.id;
  const teacherEmail = lesson?.teacher?.email;
  const teacherPart = teacherId
    ? `id:${teacherId}`
    : teacherEmail
      ? `email:${String(teacherEmail).toLowerCase()}`
      : "";
  const sessionStart = getSessionStartKey(lesson);

  if (classId) {
    return `class:${classId}|teacher:${teacherPart}|${sessionStart}`;
  }
  return `lesson:${lesson?.id || ""}|teacher:${teacherPart}|${sessionStart}`;
}

export function mergeTeacherSession(base, next) {
  if (!base) return next;
  if (!next) return base;

  const statusPriority = { completed: 3, scheduled: 2, cancelled: 1 };
  const basePriority = statusPriority[base.status] || 0;
  const nextPriority = statusPriority[next.status] || 0;

  return {
    ...base,
    title: base.title || next.title,
    status: nextPriority > basePriority ? next.status : base.status,
    duration_minutes: Math.max(
      Number(base.duration_minutes) || 0,
      Number(next.duration_minutes) || 0,
    ),
    meeting_url: base.meeting_url || next.meeting_url,
    class_group: base.class_group || next.class_group,
  };
}

export function dedupeTeacherSessions(lessons) {
  const result = [];
  const seen = new Map();
  const keyToIndex = new Map();

  for (const lesson of lessons || []) {
    const key = getTeacherSessionKey(lesson);
    if (!key) {
      result.push(lesson);
      continue;
    }

    if (!seen.has(key)) {
      seen.set(key, lesson);
      keyToIndex.set(key, result.length);
      result.push(lesson);
      continue;
    }

    const merged = mergeTeacherSession(seen.get(key), lesson);
    seen.set(key, merged);
    const index = keyToIndex.get(key);
    if (typeof index === "number") {
      result[index] = merged;
    }
  }

  return result;
}
